import { H2, Span, Text } from "@/components/ui/elements";

export function PointSystemExplanation() {
  return (
    <>
      <div>
        <H2>【持ち点制度とは】</H2>
        <Text mt={5}>
          <Span fw="bold">ご登録時に10ポイント(pt)が付与されます。</Span>
          <br />
          持ち点の最大値は20ptで、
          <Span fw="bold" c="red">
            0pt以下になると応募制限となり一時的に新規の求人応募ができなくなります。
          </Span>
          <br />
          <Span fw="bold">
            また持ち点によって一度に応募できる応募数の制限がされます。
          </Span>
          <br />
          以下の条件でポイントが減少します。
          <br />
          ---
          <br />
          <Span fw="bold">・応募した求人のキャンセル</Span>
          <br />
          <Span fw="bold">・勤務に遅刻、早退</Span>
          <br />
          <Span fw="bold">・無断欠勤(１回で利用停止)</Span>
          <br />
          ---
          <br />
          また、
          <Span fw="bold" c="blue">
            勤務完了後に施設のレビュー投稿により、減少した持ち点を回復することができます。
          </Span>
        </Text>
      </div>
      <div>
        <H2>【応募制限について】</H2>
        <Text mt={5}>
          応募制限期間中は
          <Span fw="bold">新規の求人応募が制限されます。</Span>
          <br />
          <Span fw="bold">応募済みの求人は、勤務可能です。</Span>
          <br />
          <Span fw="bold" c="blue">
            ワーカー限定公開の求人のみ応募可能です。
          </Span>
          <br />
          <Span fw="bold" c="red">
            応募制限期間は応募制限履歴、勤務実績や評価に応じて変動します。
          </Span>
        </Text>
      </div>
      <div>
        <H2>【利用停止について】</H2>
        <Text mt={5}>
          <Span fw="bold" c="red">
            無断欠勤などの重大な違反により利用停止となります。
          </Span>
          <br />
          <Span fw="bold">応募済みの求人は全てキャンセルされます。</Span>
          <br />
          <Span fw="bold" c="red">
            全ての求人への応募が不可となります（ワーカー限定公開も含む）。
          </Span>
          <br />
        </Text>
      </div>
    </>
  );
}
